export default "__VITE_ASSET__BnjHyzrt__"